import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { PsychologistService as SharedPsychologistService } from '@avanta/shared/services/psychologists';
import { type Psychologist, type Rating } from '@avanta/shared/types/psychologists';
import { type AxiosResponse } from 'axios';

const PSYCHOLOGIST_URL = `${BASE_URL}psychologists`;

export interface PsychologistServiceTypes {
  getPsychologist: (psychologistId: string) => Promise<AxiosResponse<Psychologist>>;
  getPsychologistRatings: (psychologistId: string) => Promise<AxiosResponse<Rating[]>>;
}

export const PsychologistService: PsychologistServiceTypes = {
  getPsychologist: SharedPsychologistService.getPsychologist,
  getPsychologistRatings: async psychologistId =>
    service.get(`${PSYCHOLOGIST_URL}/${psychologistId}/ratings`),
};
